// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1egGz","inputWrap":"CustomTip_inputWrap__1bF2x"};